/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { useDeepCompareMemo } from "hooks/use-deep-compare-memo";
import { isObjectEmpty, isString } from "utils/empty-exists";
// import { quillToHtml } from "./rich-text-utils"
import { tipTapToHtml } from "./rich-text-utils";
import { Logger } from "cms/utils/log/logger";

export function isRichTextQuill (richtext) {
    return !!richtext?.ops;
}

const DEFAULT_HTML = "<p></p>";

/**
 * Convert Quill or TipTap to HTML
 * Returns early where it can to prevent expensive 
 * @param {any} richtext
 * @returns {string}
 */
export function useRichTextToHtml (richtext) {
    const html = useDeepCompareMemo(() => {
        
        // handle null, undefined, empty string, and empty object
        if (!richtext || isObjectEmpty(richtext)) {
            return DEFAULT_HTML;
        }
        
        // handle a non-empty string passed to it
        if (isString(richtext)) {
            return richtext;
        }
        
        // const isQuill = isRichTextQuill(richtext)
        let html = "";
        try {
            // html = isQuill ? quillToHtml(richtext) : tipTapToHtml(richtext)
            html = tipTapToHtml(richtext);
        } catch (error) {
            Logger.warn(error);
            console.warn(error);
            html = `<details class="richtext-error">
                <summary>ERROR: Failed to read rich text content: ${error.message}</summary>
                <pre class="richtext_debug">${JSON.stringify(richtext,null,2)}</pre>
                </details>`;
        }
        return html;
        
    }, [richtext]);

    return html;
}

